import { Component, EventEmitter, Input, Output, AfterViewInit,ViewChild } from '@angular/core';
import { Constant, BaseComponent,DatePickerFormatter } from 'app/infrastructure/common/index';
import { OnlineShippingNoticeService } from 'app/infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service';
import {SelectItem} from 'primeng/primeng';
import { AdvancedShippingNotice} from 'app/data/models/transaction/op/inbound/asn';
import { UserService } from 'app/infrastructure/services/base';
import {
    ContractDetailsService,
    HolidayService,
} from 'app/infrastructure/services/transaction/op/outbound/order';

import * as _ from 'lodash';
import * as moment from 'moment';

declare var jQuery: any;

@Component({
    selector: 'app-fill-info',
    templateUrl: './fill-info.html',
    styleUrls: ['./fill-info.css']
})
export class ASNFillInfoComponent extends BaseComponent implements AfterViewInit {
    @Output() selectProductsEvent = new EventEmitter<any>();
    @Output() goBackEvent = new EventEmitter<any>();
    @Output() goToFirstEvent = new EventEmitter<any>();

    @Input() ownerCode: string;
    @Input() asn: AdvancedShippingNotice;

    searchText:string = null;

    isLoading:boolean = false;
    isLoadingTranscode:boolean = false;
    isLoadingSupplier:boolean = false;
    isLoadingHoliday:boolean = false;
    isLoadingEmail:boolean = false;
    //showErrorSupplier:boolean = false;

    transCodes:SelectItem[] = [];
    suppliers:any[];
    additionalServices: any[];
    fromSelectedAdditionalServices: any[] = [];    
    toSelectedAdditionalServices: any[] = [];
    holidayDates: Date[] = [];
    uploadedFile: File;
    documentDescription: string;
    @ViewChild('UploadFileInput') UploadFileInput: any;

    constructor(private onlineShippingNoticeService : OnlineShippingNoticeService,
        private contractDetailsService: ContractDetailsService,
        private holidayService: HolidayService,
        private userService: UserService){
        super();
    }
    ngOnInit(): void {
        this.initialize(this);
    }
	
    showDatePicker(idEl) {
        jQuery('#' + idEl).datepicker('show');
    }

    initialize(self:this){
        self.loadTranscodes(self);
        self.loadAdditionalServices(self);
        self.loadHolidays(self);
        self.loadEmail(self);
        if(self.asn.Supplier != null)
            self.searchSupplier(self.asn.Supplier);
    }
    loadTranscodes(self:this){
        self.isLoadingTranscode = true;
        this.onlineShippingNoticeService.requestGetAsnTranscodes()
            .subscribe(data => {
                self.isLoadingTranscode = false;
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        message.Result.forEach(obj => {
                            self.transCodes.push({label:obj.TransCode, value:obj.TransCode});
                        });
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                }
            },
            error => {
                self.isLoadingTranscode = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            });
    }
    loadHolidays(self:this): void {
        this.isLoadingHoliday = true;

        let today = new Date();
        this.holidayService.getIncomingHolidays(today)
            .subscribe(
                data => {
                    self.isLoadingHoliday = false;

                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            let holidays = message.Result;
                            if (holidays) {
                                holidays.forEach(item => {
                                    self.holidayDates.push(new Date(item.HolidayDate));
                                });
                            }
                        }
                        else {
                            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                    }
                },
                error => {
                    self.isLoadingHoliday = false;
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                }
            );
    }
    loadEmail(self:this): void {
        this.isLoadingEmail = true;

        this.userService.getGetUserById(this.token.UserId)
            .subscribe(
                data => {
                    self.isLoadingEmail = false;

                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            let user = message.Result;
                            self.asn.Email = user.Email;
                        }
                        else {
                            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                    }
                },
                error => {
                    self.isLoadingEmail = false;
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                }
            );
    }
    loadAdditionalServices(self:this): void {
        let divisionCode: string = this.token ? this.token.DefaultDivisionCode : null;
        this.contractDetailsService.getContractDetailsWithChargeDescriptionByOwnerDivision(this.ownerCode, divisionCode, Constant.defaultAsnServiceType)
            .subscribe(
                data => {
                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            self.additionalServices = message.Result;
                            self.additionalServices.sort(self.sortAdditionalServices);
                            if (self.asn.OnlineShippingNoticeServices){                                                                
                                let newData = [];
                                self.asn.OnlineShippingNoticeServices.forEach(function (item) {
                                    let additionalService = _.find(self.additionalServices, function (obj) {
                                        return obj.Id === item.Id;
                                    });
    
                                    if (additionalService) {
                                        let index = self.additionalServices.indexOf(additionalService);
                                        self.additionalServices.splice(index, 1);
                                        newData.push(additionalService);
                                    }
                                });
                                self.asn.OnlineShippingNoticeServices = newData;
                            }
                        }
                        else {
                            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                    }
                },
                error => {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                }
            );
    }
    setServices() {
        for (let i = 0; i < this.fromSelectedAdditionalServices.length; ++i) {
            let item = this.fromSelectedAdditionalServices[i];
            this.asn.OnlineShippingNoticeServices.push(item);

            let index = this.additionalServices.indexOf(item);
            this.additionalServices.splice(index, 1);
        }
        this.fromSelectedAdditionalServices = [];
    }

    unsetServices() {
        for (let i = 0; i < this.toSelectedAdditionalServices.length; ++i) {
            let item = this.toSelectedAdditionalServices[i];
            this.additionalServices.push(item);

            let index = this.asn.OnlineShippingNoticeServices.indexOf(item);
            this.asn.OnlineShippingNoticeServices.splice(index, 1);
        }
        this.additionalServices.sort(this.sortAdditionalServices);
        this.toSelectedAdditionalServices = [];
    }
    sortAdditionalServices(a, b) {
        if (a.ChargeDescription < b.ChargeDescription) return -1;
        if (a.ChargeDescription > b.ChargeDescription) return 1;
        return 0;
    }
    ngAfterViewInit(): void {
        var self = this;
        jQuery('.mydatepicker').datepicker({
            autoclose: true,
            clearBtn: true,
            format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription),
            daysOfWeekDisabled: [0],
            beforeShowDay: function (date) {
                if (self.isLoadingHoliday)
                    return false;

                if (self.holidayDates) {
                    for (let i = 0; i < self.holidayDates.length; i++) {
                        let holiday = self.holidayDates[i];
                        if (date.toDateString() == holiday.toDateString()) {
                            return false;
                        }
                    }
                }
                return true;
            }

        }).on('show', (e) => {
            let sameDayTimeDiff = 0;
            let dateDiff = 0;
            let saturday = 6;
            let today = moment();
            let isSaturday: boolean = today.toDate().getDay() == saturday;

            let nextDay = self.defineNexDay();
            let startDate = 'today';

            if (isSaturday || sameDayTimeDiff > 0) {
                dateDiff = nextDay.diff(today.startOf('day'), 'days');
                startDate = '+' + dateDiff + 'd';
            }
            jQuery('.mydatepicker').datepicker('setStartDate', startDate);
        }).on('change', (e) => {
            self.asn.EtaDateString = e.target.value;
        });
    }
    defineNexDay(): moment.Moment {
        const self = this;

        let saturday = 6;
        let today = moment();
        let nextDay = moment().startOf('day').add(1, 'days');
        let isSaturday: boolean = today.toDate().getDay() == saturday;

        if (isSaturday) {
            nextDay.add(1, 'days');
        }
        while (self.holidayDates && self.holidayDates.map(Number).indexOf(+nextDay) != -1) {
            nextDay.add(1, 'days');
        }
        return nextDay;
    }
    searchSupplier(supplierCode:string){
        let self = this;
        self.isLoadingSupplier = true;

        if(supplierCode != null){
            this.onlineShippingNoticeService.requestGetProductSuppliers(supplierCode)
            .subscribe(data => {
                self.isLoadingSupplier = false;
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.suppliers = message.Result;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                }
            },
            error => {
                self.isLoadingSupplier = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            });
        }else{
            if(self.searchText != null && self.searchText != ""){
                self.asn.Supplier = null;
                self.asn.SupplierName = null;
                this.onlineShippingNoticeService.requestGetProductSuppliers(this.searchText)
                .subscribe(data => {
                    self.isLoadingSupplier = false;
                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            self.suppliers = message.Result;
                        }
                        else {
                            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        }
                    }
                    else {
                        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                    }
                },
                error => {
                    self.isLoadingSupplier = false;
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                });
            }else{
                self.isLoadingSupplier = false;
                self.showAlert("Keyword cannot be empty", Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
            }
        }
    }
    changeUploadedFile(event) {
        let uploadedFiles: FileList = event.target.files;
        if (uploadedFiles.length > 0) {
            this.uploadedFile = uploadedFiles.item(0);
        }
    }
    canSaveDocument(): boolean {
        return this.uploadedFile != undefined;
    }

    saveDocument() {
        // Read file data
        let fileData: any[] = [];
        let reader = new FileReader();

        reader.onload = function () {
            let arr = new Uint8Array(this.result);

            for (var i = 0; i < arr.length; i++) {
                fileData[i] = arr[i];
            }
        }
        reader.readAsArrayBuffer(this.uploadedFile);

        let fileName = this.getUploadedFileName();
        // save document
        let document = {
            FileName: fileName,
            Description: this.documentDescription,
            FileData: fileData,
            FileType: this.uploadedFile.type,
            CreatedBy: this.token.UserId,
            UpdatedBy: this.token.UserId
        };

        this.asn.OnlineShippingNoticeDocuments.push(document);

        // Reset uploaded file
        this.clearUploadedFile();
    }
    getUploadedFileName(): string {
        console.log(this.asn);
        // Check for duplicated file name
        let fileName = this.uploadedFile.name;
        let duplicatedFileName = this.asn.OnlineShippingNoticeDocuments.find(d => d.FileName == fileName);

        if (duplicatedFileName) {
            let name = fileName.substr(0, fileName.lastIndexOf('.'));
            let fileExt = fileName.substr(name.length, fileName.length - 1);

            let seqNumbers: number[] = [];
            this.asn.OnlineShippingNoticeDocuments.forEach(function (item) {
                let regex = /[0-9]+(?!.*[0-9])/;
                if (item.FileName.match(regex)) {
                    seqNumbers.push(parseInt(item.FileName.match(regex).toString()));
                }
            });
            let seqNo = 1;
            if (seqNumbers.length > 0) {
                seqNo = Math.max.apply(Math, seqNumbers) + 1;
            }
            fileName = name + '_' + seqNo + fileExt;
        }
        return fileName;
    }

    clearUploadedFile() {
        this.uploadedFile = null;
        this.documentDescription = '';
        this.UploadFileInput.nativeElement.value = '';
    }
    showDocument(document) {
        var fileData = new Uint8Array(document.FileData);
        let objectURL = URL.createObjectURL(new Blob([fileData], { type: document.FileType }));
        window.open(objectURL);
    }

    deleteDocument(document) {
        let index = this.asn.OnlineShippingNoticeDocuments.indexOf(document);
        this.asn.OnlineShippingNoticeDocuments.splice(index, 1);
    }
    canSaveAsDraft(): boolean {
        return (this.asn.OopAsnNo == null || this.asn.StatusCode == Constant.OnlineShippingNoticeStatus.draft);
    }
    goBack(){
        this.goBackEvent.emit();
    }
    completeForm(){
        this.asn.DateFormat = this.token.DateFormatDescription;
        this.asn.SupplierName = this.asn.Supplier != null ? this.suppliers.find(x=> x.SupplierCode == this.asn.Supplier).SupplierName : "";
        this.asn.WhsCode = this.token.DefaultWarehouseCode;
        this.asn.OwnerCode = this.ownerCode;
        this.asn.CreatedBy = this.token.UserId;
        this.asn.UpdatedBy = this.token.UserId;
    }
    saveAsDraft(isValid:boolean){
        let self = this;
        if(isValid){
            // if(self.asn.Supplier != null){
            //     self.showErrorSupplier = false;
            //     self.completeForm();
            //     self.isLoading = true;
            //     self.asn.StatusCode = Constant.OnlineShippingNoticeStatus.draft;
            //     self.onlineShippingNoticeService.saveOnlineShippingNotice(self.asn)
            //     .subscribe(
            //     data => {
            //             self.isLoading = false;
            //             let message = data;
            //             if (message && message.MessageType && message.MessageType.Value) {
            //                 self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
            //                 if (message.MessageType.Value == Constant.MessageType.success) {
            //                     self.asn = message.Result;
            //                     self.goToFirstEvent.emit();
            //                 }
            //             }
            //             else {
            //                 self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
            //             }
            //         },
            //         error => {
            //             self.isLoading = false;
            //             self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            //         });
            // }else
            //     self.showErrorSupplier = false;
            self.completeForm();
            self.isLoading = true;
            self.asn.StatusCode = Constant.OnlineShippingNoticeStatus.draft;
            self.onlineShippingNoticeService.saveOnlineShippingNotice(self.asn)
            .subscribe(
            data => {
                    self.isLoading = false;
                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        self.showMessage(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                        if (message.MessageType.Value == Constant.MessageType.success) {
                            self.asn = message.Result;
                            self.goToFirstEvent.emit();
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                    }
                },
                error => {
                    self.isLoading = false;
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                });
        }
    }
    selectASNProduct(isValid:boolean) {
        if(isValid){
            // if(this.asn.Supplier != null){
            //     this.showErrorSupplier = false;
            //     this.completeForm();
            //     this.selectProductsEvent.emit(this.asn);
            // }else
            //     this.showErrorSupplier = false;
            this.completeForm();
            this.selectProductsEvent.emit(this.asn);
        }
    }
    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/inbound/asn/submit-asn/fill-info/fill-info.component.ts